import React from "react";
import {
	BooleanInput,
	CheckboxGroupInput,
	NumberInput,
	ReferenceArrayInput,
	required,
	SelectInput,
	SimpleForm,
	TextInput,
	useTranslate,
} from "react-admin";
import CodeInput from "../components/inputs/CodeInput";
import { formatMany, parseMany } from "../utils/parsing";

const map = (v) => ({ id: v, name: v });
const types = ["none", "referral"].map(map);
const valueTypes = ["number", "money", "percent", "float"].map(map);
const valueFormatters = ["number", "money"].map(map);

const Form = (props) => {
	const translate = useTranslate();
	return (
		<SimpleForm {...props} redirect="list">
			<TextInput source="code" validate={required()} fullWidth />
			<TextInput source="name" validate={required()} fullWidth />
			<NumberInput source="order" validate={required()} />
			<SelectInput source="type" choices={types} validate={required()} />
			<SelectInput
				source="value_type"
				choices={valueTypes}
				fullWidth
				validate={required()}
			/>
			<SelectInput
				source="value_formatter"
				choices={valueFormatters}
				fullWidth
				validate={required()}
			/>
			<BooleanInput
				source="show_deal"
				helperText={translate("resources.events.fields.show_deal.help")}
			/>
			<BooleanInput
				source="show_column"
				helperText={translate("resources.events.fields.show_column.help")}
			/>
			<BooleanInput source="is_money" />
			<CodeInput source="sql_expr" type="sql" fullWidth defaultValue="" />
			<ReferenceArrayInput
				source="roles"
				reference="roles"
				fullWidth
				parse={parseMany}
				format={formatMany}
			>
				<CheckboxGroupInput optionText="name" />
			</ReferenceArrayInput>
		</SimpleForm>
	);
};
export default Form;
